import { Avatar } from "../../components/avatar/Avatar";
import IPerson from "../../models/people/IPerson";
import styles from "./TableRow.module.scss";

interface ITableRowProps {
    person: IPerson;
    openModal: (personId: string) => void;
}

export const TableRow = (props: ITableRowProps) => {
    const { person, openModal } = props;

    const handleOpenModal = () => openModal(person.id);

    const name = person.name;
    const photoUrl = `${process.env.REACT_APP_API_BASE_URL}people/${person.id}/photo`;

    return (
        <tr className={styles.row} onClick={handleOpenModal}>
            <th>
                <div className={styles.nameCell}>
                    <div className={styles.photo}>
                        <Avatar src={photoUrl} name={name} alt={name} size="xs" />
                    </div>
                    <span className={styles.name}>{name}</span>
                </div>
            </th>
            <td>{person.position}</td>
            <td>{person.team}</td>
            <td>{person.country}</td>
            <td>{person.region}</td>
        </tr>
    );
}